export function encryptParams(p) {
  return p;
}

export function formatNumber(num) {
  if(!num) {
    return 0
  }
  return num.toLocaleString('en-US');
}

export const CheckSortBy  = (key) => {
  switch (key) {
    case "ascend":
      return"asc"
      break;
    case "descend":
      return "desc"
      break;
  
    default:
      return ""
      break;
  }
}

export const formatFileSize = (size) => {
  if(!size) {
    return `0 MB`;
  }
  let mb = (size - 0)  / 1024 / 1024
  // return `${(mb).toFixed(2)} MB`;
  if (size < 1024) return `${size} bytes`;
  else if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
  else return `${(size / 1024 / 1024).toFixed(2)} MB`;
};

export const getFileType = (url="") => {
  if (!url) return "";
  const cleanUrl = url.split('?')[0].split('#')[0];
  const lastDot = cleanUrl.lastIndexOf('.');
  if (lastDot === -1) return "";
  const ext = cleanUrl.substring(lastDot + 1);
  return ext;
}

export const isEmptyObject = itemData => Object.keys(itemData).length === 0;


export const timeToSeconds = (timeStr) => {
  // Examples:
  // console.log(timeToSeconds("01:50:30")); // 6630
  // console.log(timeToSeconds("50:30"));    // 3030
    const parts = timeStr.split(':').map(Number);
    let seconds = 0;

    if (parts.length === 3) { // hh:mm:ss
      seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
    } else if (parts.length === 2) { // mm:ss
      seconds = parts[0] * 60 + parts[1];
    } else if (parts.length === 1) { // ss
      seconds = parts[0];
    }

    return seconds;
  }

  export const secondsToTime = (seconds) => {
  // console.log(secondsToTime(6630)); // "01:50:30"
  // console.log(secondsToTime(3030)); // "50:30"
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);

    if (h > 0) {
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    } else {
      return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }
  }

export const sliceWord20character = (textName) => {
  let text = textName && textName && textName ? textName : ''
    const languages = textName ?  Object.keys(textName) : []
    if (!text) {
      for (let lang of languages) {
        if (textName && textName[lang] && textName[lang]) {
          text = textName[lang];
          break;
        }
      }
    }
    return text
}